import moment from 'moment';

export const numDaysDisplayed = 14;

export const getTimeFromStartTime = (time, format) => {
  if (!time) {
    return null;
  }

  return moment
    .utc()
    .startOf('day')
    .add(time, 'minutes')
    .format(format);
};

export const getDayOfTheWeek = index =>
  moment(index, 'e')
    .startOf('week')
    .isoWeekday(index)
    .format('ddd');

export const getFullDayOfTheWeek = index =>
  moment(index, 'e')
    .startOf('week')
    .isoWeekday(index)
    .format('dddd');

export const getDateForScreenReader = date =>
  moment(date).format('dddd, MMMM Do');

export const groupSlotsByDate = slots =>
  slots.reduce((arr, item) => {
    const { date } = item;
    if (!arr[date]) {
       
      arr[date] = [item];
      return arr;
    }
    arr[date].push(item);
    return arr;
  }, {});

export const getDatesToDisplay = (format, startDate) => {
  if (!startDate) {
    return undefined;
  }

  let numDays = 0;
  const days = [];
  while (numDays < numDaysDisplayed) {
    /* eslint no-underscore-dangle: 0 */
    const day = moment(startDate.startOf('week')._d)
      .startOf('day')
      .clone()
      .add(numDays, 'day')
      .format(format);
    days.push(day);
    numDays += 1;
  }
  return days;
};

export const getActiveSlots = (startDate, slots) => {
  if (!startDate) {
    return null;
  }
  const groupedSlots = groupSlotsByDate(slots);
  const days = getDatesToDisplay('YYYY-MM-DD', startDate);
  const active = days.reduce((arr, day) => {
     
    arr[day] = groupedSlots[day] || [];
    return arr;
  }, {});
  const sortedActive = {};
  Object.keys(active).forEach(key => {
    const sorted = active[key].sort((a, b) => a.time - b.time);
    sortedActive[key] = sorted;
  });
  return sortedActive;
};

export const getHoursToDisplay = (start, end) => {
  if (start === 0 && end === 0) {
    return 'Closed';
  }
  const format = 'h:mm a';
  return `${getTimeFromStartTime(start, format)} - ${getTimeFromStartTime(
    end,
    format,
  )}`;
};

export const getHoursForScreenReader = (start, end) =>
  getHoursToDisplay(start, end)
    .replace('-', 'to')
    .replace(/:00/g, '');

export const getNearestDateWithSlots = slots => {
  const groupedSlots = groupSlotsByDate(slots);
  const date = Object.keys(groupedSlots).find(d => groupedSlots[d].length > 0);
  return date;
};
